import React, { useState } from 'react';

const Select = ({ options, placeholder, value, onChange, className, bgColor = '#FFFFFF' }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionClick = option => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <div className={className}>
      <div
        className="flex justify-between items-center  w-full rounded-[40px] py-[15px] px-[27px] cursor-pointer shadow-[0px_4px_6.9px_0px_#26262817]"
        onClick={() => setIsOpen(!isOpen)}
        style={{ backgroundColor: bgColor }}
      >
        <span className="text-[16px] font-[600] leading-[20px] text-[#0052B4] ">{value ? value : placeholder}</span>

        <svg
          className={`transition-transform duration-300 ease ${isOpen ? 'rotate-[-90deg]' : ''}`}
          width="20"
          height="12"
          viewBox="0 0 20 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1.77 0.115234L-7.73692e-08 1.88523L10 11.8852L20 1.88523L18.23 0.115234L10 8.34523L1.77 0.115234Z" fill="#09AF77" />
        </svg>
      </div>
      {isOpen && (
        <ul
          className="absolute left-0 top-[30px] w-full  px-[27px] py-[15px] rounded-b-[30px] mt-1 shadow-[0px_4px_6.9px_0px_#26262817]"
          style={{ backgroundColor: bgColor }}
        >
          {options.map(option => (
            <li
              key={option.value}
              className="p-2 cursor-pointer py-[5px] hover:bg-gray-100 border-b-1"
              onClick={() => handleOptionClick(option.label)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Select;
